import React from 'react';
import VenueConductorModal from '../components/VenueConductorModal';

const VenueConductorModalApp = (props) => <VenueConductorModal {...props} />;

export default VenueConductorModalApp;
